export default function canBeDisplayed(log, pageviewGoal, fingerprint) {
    if (pageviewGoal < 0) {
        log.error('Pageview goal is negative, ALWAYS displaying module');
        return true;
    }
    const key = `discovery-unit-${fingerprint}-${pageviewGoal}`;
    // if there's no local storage, we can't show the discovery unit
    if (!window.sessionStorage) {
        log.debug('sessionStorage is not available, cannot show module');
        return false;
    }
    // get value from sessionStorage
    let pageviewCounter = parseInt(sessionStorage.getItem(key), 10);
    // increase value by 1 if it is valid, otherwise set it to 0
    pageviewCounter = pageviewCounter >= 0 ? pageviewCounter + 1 : 0;
    // save value to sessionStorage
    sessionStorage.setItem(key, pageviewCounter.toString());
    // if the value is equal to the pageview goal, we can show the discovery unit
    if (pageviewCounter === pageviewGoal) {
        log.debug('Module can be displayed', { pageviewCounter, pageviewGoal });
        return true;
    }
    log.debug('Module cannot be displayed', { pageviewCounter, pageviewGoal });
    return false;
}
